import React from 'react';

import StarBorderIcon from '@mui/icons-material/StarBorder';

const DynamicComponent = ({ componentName, componentRegistry = {}, ...props }) => {
  const Component = componentRegistry[componentName];

  if (!Component) {
    return <StarBorderIcon fontSize='small' />;
  }

  return <Component {...props} />;
};

export default DynamicComponent;
